module.exports = __webpack_public_path__ + "ca515c17952c16fad1eb84cea638bbd9.svg";